import {Decoder, field, number, object, string} from 'json-bouncer'

export interface Customer {
    id: number
    shortName: string
    longName: string
    defaultProductShippingServiceId: number
}

export function customerDecoder(): Decoder<Customer> {
    return object({
        id: field('id', number()),
        shortName: field('shortName', string()),
        longName: field('longName', string()),
        defaultProductShippingServiceId:
            field('defaultProductShippingServiceId', number()),
    })
}

export function label(customer: Customer): string {
    return customer.longName
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Entities/Customer.ts